module.exports = __webpack_public_path__ + "img/guangGong3.52a0cd01.png";